import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface SupportedCurrencies {
  transactionCurrencies: string[];
}

export default (makeCall: MakeCall) => () =>
  makeCall<SupportedCurrencies>(
    'GET',
    `/api/v2/payment/configuration/currencies`,
  );
